module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-29-53f738bae3b1a55c048b9bb3375d69db.png";